import { z } from 'zod';

export const loginSchema = z.object({
  /**
   * The password of the user attempting to log in.
   * [REQUIRED]: This is used to authenticate the user attempting to log in.
   */
  password: z
    .string({
      required_error: 'Password is required',
      invalid_type_error: 'Password must be a string',
    })
    .min(1, { message: 'Password is required' }),
  /**
   * The token data of the user attempting to log in.
   * [OPTIONAL]: This is used to identify the device of the user attempting to log in.
   */
  tokenData: z
    .object({
      deviceId: z.string().optional(),
      deviceToken: z.string().optional(),
      deviceType: z.string().optional(),
    })
    .optional(),
  /**
   * The username of the user attempting to log in.
   * [REQUIRED]: This is used to identify the user attempting to log in.
   */
  username: z
    .string({
      required_error: 'Username is required',
      invalid_type_error: 'Username must be a string',
    })
    .min(1, { message: 'Username is required' }),
});
